import * as React from "react"
import { Box, Link } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { capitalize } from "@ui-seeker/utils"

import { ImageSkuBlock } from "@components"
import { useBuildExternalURL } from "@hooks"
import {
    monitoringResultsTableBrandFilter,
    monitoringResultsTableEANFilter,
    monitoringResultsTableProductFilter,
    monitoringResultsTableRefFilter
} from "../../@signals";


const IMAGE_SIZE = 120

export default function productColumn({ showMinMaxPrices=false }) {
    return [{
        name: "brand", label: 'Brand',
        options: {
            display: 'excluded',
            filterList: monitoringResultsTableBrandFilter.value
        }
    }, {
        name: "ean", label: 'EAN',
        options: {
            display: 'excluded',
            filterList: monitoringResultsTableEANFilter.value,
            filterType: 'textField'
        }
    }, {
        name: "reference", label: 'Reference ID',
        options: {
            display: 'excluded',
            filterList: monitoringResultsTableRefFilter.value,
            filterType: 'textField'
        }
    }, {
        name: 'sku', label: 'Product',
        options: {
            filterType: 'textField',
            filterList: monitoringResultsTableProductFilter.value,
            setCellProps: () => ({ sx: { width: 640 } }),
            customBodyRowRenderLite: (value, { company, brand, ean, skuID, reference, rowPrices, mainSiteID, mainProductID, minPriceSku, maxPriceSku }) => {
                if (!rowPrices) return <></>

				const { productURL } = useBuildExternalURL({
					siteData: { siteID: mainSiteID, productID: mainProductID }
				})

                return <Box display='flex' flexDirection='row' alignItems='center' gap={1.5}>
                    <Box display="flex" justifyContent="center" width={IMAGE_SIZE} minWidth={IMAGE_SIZE}>
                        <ImageSkuBlock
                            skuID={skuID}
                            alt={value}
                            imageProps={{sx: { height: IMAGE_SIZE } }}
                        />
                    </Box>

                    <Box>
                        <Box>{company}</Box>
                        <Box>{brand}</Box>
                        <Box sx={{ fontWeight: 'bold' }}>
                            <Link href={productURL ? `${productURL}?id_sku=${skuID}` : ''} target="_blank">
                                {value.replace(capitalize(brand) + ' ', '')}
                            </Link>
                            <IconSeeker icon="up-right-from-square" sx={{ margin: .5, color: 'primary.main'}}/>
                        </Box>
                        <Box sx={{ fontSize: '0.813rem' }}><IconSeeker icon='barcode' sx={{ mr: 0.5 }} tooltip='Reference ID' /> {reference}</Box>
                        <Box sx={{ fontSize: '0.813rem' }}><IconSeeker icon='barcode-scan' sx={{ mr: 0.5 }} tooltip='EAN' /> {ean}</Box>
                        {showMinMaxPrices && <>
                            <Box display="flex" flexDirection="row" fontSize="0.813rem" gap={0.5}>
                                <Box fontWeight="bold">Max. Price: </Box>
                                <Box>{maxPriceSku}</Box>
                            </Box>
                            <Box display="flex" flexDirection="row" fontSize="0.813rem" gap={0.5}>
                                <Box fontWeight="bold">Min. Price: </Box>
                                <Box>{minPriceSku}</Box>
                            </Box>
                        </>}
                    </Box>
                </Box>
            }
        }
    }]
}